export default __webpack_public_path__ + "static/media/eventImage.a39e33ce.png";